import { KeyboardEventHandler, ReactNode, SetStateAction } from "react";
import styled from "styled-components";
import { clamp } from "@radix-ui/number";
import { Body } from "../../body/Body";

// TEXT

// STYLES
export const SliderDiscreteWrap = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-end;
`;

export const InputLabel = styled(Body)`
  display: block;
`;

// DATA

// TYPES
export type Props = {
  labels?: ReactNode[];
  value?: number[];
  disabled?: boolean;
  step?: number;
  min?: number;
  max?: number;
  setValue?: (action: SetStateAction<number | number[]>, event: Event) => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
};

// CONSTANTS

// FUNCTIONS
function getDecimalCount(value: number) {
  return (String(value).split(".")[1] || "").length;
}

function roundValue(value: number, decimalCount: number) {
  const rounder = Math.pow(10, decimalCount);
  return Math.round(value * rounder) / rounder;
}

export function clampAndSnap({
  min = 0,
  max = 100,
  step = 1,
}: {
  min: number;
  max: number;
  step: number;
}) {
  const decimalCount = getDecimalCount(step);
  return (v: number) => {
    const snapToStep = roundValue(
      Math.round((v - min) / step) * step + min,
      decimalCount,
    );
    return clamp(snapToStep, [min, max]);
  };
}

// ASSETS
